module.exports = __webpack_public_path__ + "img/trip-bee.02ed94e7.svg";